import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Editor } from 'slate-react';


const HelpEditor = ({ value, onChange, readOnly, plugins }) => (
  <div className="Help__container">
    <Editor
      className="Help__editor"
      placeholder={readOnly ? 'Edit help content here' : ''}
      value={value}
      plugins={plugins}
      onChange={onChange}
      readOnly={readOnly}
    />
  </div>
);

HelpEditor.propTypes = {
  readOnly: PropTypes.bool,
  value: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes.func,
  plugins: PropTypes.arrayOf(PropTypes.object).isRequired, // eslint-disable-line react/forbid-prop-types
};

export default memo(HelpEditor);
